<template>
    <mySubPage>
        <div slot="header">
            <myNav>{{$t("insert_user")}}</myNav>
        </div>
        <el-form class="pd-10" ref="form" :model="formData" :rules="rule" label-width="120px">
            <el-form-item :label="$t('dep_cname')">
                <el-input v-model="dep_cname" disabled/>
            </el-form-item>
            <el-form-item :label="$t('user_code')" prop="user_code">
                <el-input v-model="formData.user_code" @input="clearUserInfo"  @keyup.enter.native="searchUserInfo" :placeholder="$t('input_enter')" prefix-icon="el-icon-search"/>
            </el-form-item>
            <el-form-item :label="$t('user_cname')">
                <el-input v-model="formData.user_cname" disabled/>
            </el-form-item>
        </el-form>
        <div slot="footer">
            <div class="flex-box bg-f8">
                <div class="flex-box-bd"></div>
                <el-button style="margin-right: 8px" @click="cancel">{{$t('cancel')}}</el-button>
                <el-button type="primary" @click="submit">{{$t('save')}}</el-button>
            </div>
        </div>
    </mySubPage>
</template>

<script>
    export default {
        data:function(){
            return{
                relist: false,
                formData: {
                    dep_id:'',
                    u_id: '',
                    user_code: '',
                    user_cname: ''
                },
                rule: {
                    u_id: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                    user_code: [{required: true, message: this.$t('input'), trigger: 'blur'}]
                },
                dep_cname: ''
            }
        },
        mounted: function(){
            this.$parent.$parent.show_subview = true;
            this.formData.dep_id = this.$base.getRequest().id;
            this.dep_cname = this.$base.getRequest().dep_cname;
        },
        methods:{
            cancel: function(){
                this.$base.linkBack();
            },
            submit: function(){
                if(this.formData.u_id == ""){
                    this.$base.alertErr(this.$t('input_user_code'));
                    return;
                }
                this.$refs["form"].validate((valid) => {
                    if (valid) {
                        this.$base.showLoading();
                        this.$request.sendPost("dep/add-user",this.formData,(success,data,error)=>{
                            this.$base.hideLoading();
                            if(success){
                                this.$base.msgSuccess(error.errmsg);
                                this.relist = true;
                                this.$base.linkBack();
                            }
                            else{
                                this.$base.alertErr(error.errmsg);
                            }
                        });
                    } else {
                        this.$base.alertErr(this.$t('incomplete'));
                    }
                })
            },
            clearUserInfo: function() {
                this.formData.user_cname = this.$t('input_enter');
                this.formData.u_id = "";
            },
            searchUserInfo: function () {
                this.clearUserInfo();

                this.$base.showLoading();
                this.$request.sendPost('dep/get-add-user',this.formData,(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        if(data){
                            this.formData.user_cname = data.user_cname;
                            this.formData.u_id = data.u_id;
                        }
                    }
                    else{
                        this.$base.msgErr(error.errmsg);
                    }
                });
            }
        },
        beforeDestroy: function () {
            this.$parent.$parent.show_subview = false;
            this.$parent.$parent.relist = this.relist;
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/org/dep/dep_user.vue